var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAlert(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Alert",
    transform: "translate(-1738 -279)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_31",
    "data-name": "Rectangle 31",
    transform: "translate(1738 279)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 6,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 35,
    height: 35,
    rx: 5.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_1",
    "data-name": "Subtraction 1",
    d: "M-4116.194-6645h-19.611a2.969,2.969,0,0,1-2.6-1.5,2.97,2.97,0,0,1,0-3l9.806-17a2.97,2.97,0,0,1,2.6-1.5,2.97,2.97,0,0,1,2.6,1.5l9.805,17a2.971,2.971,0,0,1,0,3A2.969,2.969,0,0,1-4116.194-6645Zm-9.533-7.247a1.154,1.154,0,0,0-.847.348,1.133,1.133,0,0,0-.348.835,1.147,1.147,0,0,0,.348.843,1.171,1.171,0,0,0,.847.35,1.125,1.125,0,0,0,.585-.161,1.282,1.282,0,0,0,.435-.433,1.164,1.164,0,0,0,.172-.6,1.151,1.151,0,0,0-.363-.835A1.162,1.162,0,0,0-4125.727-6652.248Zm-1.11-7.934.2,7.129h1.819l.194-7.129Z",
    transform: "translate(5882 6953)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/Alert.663b80a47e5380048fbe8bfaea26fdc9.svg";
export { ForwardRef as ReactComponent };